import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { Icon, IconButton, Typography } from '@elements';
import BackArrow from '@images/back-arrow.svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var PageTitle = function PageTitle(_ref) {
  var backRoute = _ref.backRoute;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var navigate = useNavigate();

  var backButtonClickHandler = function backButtonClickHandler() {
    if (backRoute) {
      navigate(backRoute);
    } else {
      navigate(-1);
    }
  };

  return /*#__PURE__*/_jsx(Box, {
    py: 1,
    children: /*#__PURE__*/_jsx(IconButton, {
      onClick: backButtonClickHandler,
      children: /*#__PURE__*/_jsxs(Box, {
        display: "flex",
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(Icon, {
          src: BackArrow,
          width: 14,
          height: 14
        }), /*#__PURE__*/_jsx(Box, {
          display: "flex",
          pl: 0.5,
          pt: 0.5,
          children: /*#__PURE__*/_jsx(Typography, {
            variant: "body1",
            color: "silverChalice",
            fontWeight: 400,
            component: "span",
            children: t('components.buttons.backShort')
          })
        })]
      })
    })
  });
};

export { PageTitle };